import urlJoin from 'url-join';

export const RELEASE_STAGE = process.env.STAGE || 'development';
export const API_ROOT_ENV = process.env.API_ROOT_ENV;
const getApiRoot = () => {
  switch (RELEASE_STAGE) {
    case 'production':
      return 'https://api.viresmo.com';
    case 'staging':
      return 'https://staging-api.viresmo.com';
    default:
      return API_ROOT_ENV || 'http://localhost:4000';
  }
};
export const COMMIT_SHA = process.env.VERCEL_GITHUB_COMMIT_SHA;
export const BUILD_ID = process.env.NEXT_BUILD_ID;
export const API_ROOT = getApiRoot();
export const GRAPHQL_ENDPOINT = urlJoin(API_ROOT, '/graphql');

/** Public dashboard origin. Production canonical is www (already indexed). */
const getCanonicalOrigin = () => {
  switch (RELEASE_STAGE) {
    case 'production':
      return 'https://www.viresmo.com';
    case 'staging':
      return 'https://staging-app.viresmo.com';
    default:
      return 'http://localhost:3200';
  }
};
export const CANONICAL_ORIGIN = getCanonicalOrigin();

export const REFRESH_POLL_INTERVAL = 30000;
export const UPLOAD_SIZE_LIMIT = 25;
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const SUPPORT_EMAIL = 'support@viresmo.com';

/** Suggested shops from orders-page CTA, used on print-hub claim page. */
export const PRINT_HUB_SUGGESTED_SHOPS_KEY = 'printHub.suggestedShopIds';

/** Query flag that keeps the printer modal open on the orders page. */
export const PRINT_HUB_PRINTER_QUERY = 'printer';

/** Stable public GCS installers (overwritten on each print-hub release). */
export const PRINT_HUB_DOWNLOAD_URL_WINDOWS =
  process.env.NEXT_PUBLIC_PRINT_HUB_DOWNLOAD_URL_WINDOWS ||
  'https://storage.googleapis.com/viresmo-print-hub/viresmo-print-hub-windows.exe';
export const PRINT_HUB_DOWNLOAD_URL_MACOS_ARM64 =
  process.env.NEXT_PUBLIC_PRINT_HUB_DOWNLOAD_URL_MACOS_ARM64 ||
  'https://storage.googleapis.com/viresmo-print-hub/viresmo-print-hub-macos-arm64.dmg';
export const PRINT_HUB_DOWNLOAD_URL_MACOS_X64 =
  process.env.NEXT_PUBLIC_PRINT_HUB_DOWNLOAD_URL_MACOS_X64 ||
  'https://storage.googleapis.com/viresmo-print-hub/viresmo-print-hub-macos-x64.dmg';
